<template>
  <Card>
    <AjaxForm v-if="department" :route="'admin/TicketDepartment/Edit/'+department._id">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6">
          <CustomInput v-model="department.title" type="text" name="title" label="عنوان" ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <CustomInput type="number" name="sort" v-model="department.sort" label="اولویت(عدد)" ></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-12">
          <CustomInput input_style="twoLine" type="textarea" v-model="department.description" label="توضیحات" name="description"></CustomInput>
        </div>
      </div>
      <div class="row">
        <div class="col-10 col-sm-8 col-md-5 mx-auto my-3">
          <button class="btn btn-info btn-block">ویرایش اطلاعات دپارتمان</button>
        </div>
      </div>
    </AjaxForm>
    <div v-if="error" class="alert alert-danger">
      {{error}}
    </div>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {mapActions} from "vuex";
import {TicketApi} from "@/api/TicketApi";
export default {
  name: "TicketDepartmentEdit",
  components: {CustomInput, AjaxForm, Card},
  data()
  {
    return{
      id : this.$route.params.id,
      department : null,
      error : null,
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('ویرایش اطلاعات دپارتمان تیکت');
    this.setShowHead(true);
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.department = null;
      this.error = null;
      this.id = this.$route.params.id;
      const result = await TicketApi.getTicketDepartmentInfoForEdit(this.id);
      if (result.ok)
      {
        this.department = result.department;
      }
      else
        this.error = result.error;
      this.setPageLoading(false);
    }
  }
}
</script>

<style scoped>

</style>